var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/mobile-nav/MobileMenuButton.tsx",
  _this = this;
import React from 'react';
import { useHeaderTheme } from '../../theme';
import useStyles from './useStylesMenuButton';
export var MobileMenuButton = function MobileMenuButton(_ref) {
  var showMobileNav = _ref.showMobileNav,
    toggleMobileNav = _ref.toggleMobileNav,
    _ref$testid = _ref.testid,
    testid = _ref$testid === void 0 ? 'mobile-menu-button' : _ref$testid,
    left = _ref.left;
  var theme = useHeaderTheme();
  var classes = useStyles({
    showMobileNav: showMobileNav,
    left: left,
    theme: theme
  });
  return /*#__PURE__*/React.createElement("button", {
    className: classes.menuButton,
    onClick: toggleMobileNav,
    type: "button",
    "data-testid": testid,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.menuButtonLineTop,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.menuButtonLineMiddleLeft,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.menuButtonLineMiddleRight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.menuButtonLineBottom,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }));
};
export default MobileMenuButton;
//# sourceMappingURL=MobileMenuButton.js.map